import { PageHeader } from "../components/Section";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const BELIEFS = [
  { q: "The Most High and His Name", a: "We believe in one true God, whose covenant name is Yahweh, revealed in Scripture as the Creator of heaven and earth, and Father of all who receive His Son." },
  { q: "The Messiah", a: "We believe that Yahshua (Jesus) is the Messiah, the Son of the living God, who died, was buried, rose again, and will return in glory." },
  { q: "The Scriptures", a: "The whole of Scripture — from Genesis to Revelation — is the inspired, inerrant, and authoritative Word of the Most High, the standard for all belief and conduct." },
  { q: "The Sabbath", a: "The seventh-day Sabbath is a perpetual sign between Yahweh and His people (Exodus 31:13). We keep it as an everlasting statute." },
  { q: "The Feasts of Yahweh", a: "We observe the appointed times (moedim) — Passover, Unleavened Bread, Firstfruits, Pentecost, Trumpets, Atonement, and Tabernacles — as commanded in Leviticus 23." },
  { q: "Baptism", a: "We practice believer's baptism by full immersion in the name of Yahshua the Messiah as an outward sign of covenant with Yahweh." },
  { q: "The Kingdom & Second Coming", a: "We await the visible, personal, and glorious return of Messiah to establish the Kingdom of Yahweh on the earth." },
  { q: "Holiness of Life", a: "We are called to be a set-apart people — holy in speech, dress, diet (per Scripture), and conduct — reflecting the character of the Most High." },
];

export default function Beliefs() {
  return (
    <div data-testid="beliefs-page">
      <PageHeader
        eyebrow="STATEMENT OF FAITH"
        title="What we believe"
        subtitle="The doctrines that shape our worship, our walk, and our witness."
        bg="https://images.unsplash.com/photo-1504052434569-70ad5836ab65?crop=entropy&cs=srgb&fm=jpg&w=1800&q=80"
      />
      <section className="py-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <Accordion type="single" collapsible className="w-full">
            {BELIEFS.map((b, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b hairline">
                <AccordionTrigger data-testid={`belief-trigger-${i}`} className="text-left font-display text-xl text-white hover:text-gold py-6">{b.q}</AccordionTrigger>
                <AccordionContent className="text-zinc-400 leading-relaxed pb-6">{b.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
